/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { withFormik } from 'formik'
const Yup = require('yup')

import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../../common/Button/Button'
import TableContent from '../../Step03m/components/TableContent'
import { Alert } from '../../../../common/Alert/Alert'
import ToolTip from '../../../../common/ToolTip/ToolTip'
import PopUp from '../../../../common/PopUp/PopUp'
import { saveAs } from 'file-saver'
import CSVReader from 'react-csv-reader'

/**
 *     Import
 *     - CSS
 */
import '../../styles/Step03.css'

/**
 * Step03 class {/quote/:id/step03}
 *
 * @class Step03FormHTML
 * @extends {React.Component<any, any>}
 */

let UploadCsv: any = null
const handleForce = data => {
    UploadCsv = data
}
let _totalExhibitsSumInsured: any = 0
// let dirtyValue: any = false

class Step03mFormHTML extends React.Component<any, any> {

    /**
     * Creates an instance of Step03FormHTML.
     *
     * @param {*} props
     * @memberof Step03mFormHTML
     */
    CsvTitle: any = ''
    constructor(props: any) {
        super(props)

        this.state = {
            exhibitsVal: 0,
            uploadMusemus: false,
            tableItems: [],
            editDirty: false,
            incomeExhibitionLimit: 0,
            outExhibitionLimit: 0,
            sumOfSpecItem: 0,
        }
    }

    componentDidMount() {
        const { totalExhibitsSumInsured, exhibitsItems, incomingExhibitionLimit, outgoingExhibitionLimit } = this.props
        window.scrollTo(0, 0)
        this._calculateSum()
        this.setState(
            {
                exhibitsVal: totalExhibitsSumInsured ? parseFloat(totalExhibitsSumInsured) : 0,
                incomeExhibitionLimit: incomingExhibitionLimit ? parseFloat(incomingExhibitionLimit) : 0,
                outExhibitionLimit: outgoingExhibitionLimit ? parseFloat(outgoingExhibitionLimit) : 0,
            },
            () => {
                this.setAllSpecItem()
            })
        _totalExhibitsSumInsured = totalExhibitsSumInsured ? totalExhibitsSumInsured : 0
        this.convertDataFiled(exhibitsItems)
    }

    componentDidUpdate(prevProps: Readonly<any>) {
        const {
            values,
            totalExhibitsSumInsured,
            exhibitsItems,
            incomingExhibitionLimit,
            outgoingExhibitionLimit,
        } = this.props

        if (prevProps.values.quoteId !== values.quoteId && values.quoteId) {
            this._calculateSum()
            this.setState(
                {
                    exhibitsVal: totalExhibitsSumInsured ? parseFloat(totalExhibitsSumInsured) : 0,
                    incomeExhibitionLimit: incomingExhibitionLimit ? parseFloat(incomingExhibitionLimit) : 0,
                    outExhibitionLimit: outgoingExhibitionLimit ? parseFloat(outgoingExhibitionLimit) : 0,
                },
                () => {
                    this.setAllSpecItem()
                })
            _totalExhibitsSumInsured = totalExhibitsSumInsured ? totalExhibitsSumInsured : 0
            this.convertDataFiled(exhibitsItems)
        }
    }
    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step03mFormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    convertDataFiled = (data) => {

        let tableItems = this.state.tableItems
        var pushItem: any = Object.keys(data).map((val, index) => {
            return {
                type: val,
                text: val,
                valueInsured: Number(data[val]),
            }
        })

        tableItems = [...tableItems, ...pushItem]
        this._updateParentStateItems(tableItems)

    }

    handleBlur = (event) => {
        let val = event.target.value
        this.setState({ exhibitsVal: val ? parseFloat(val) : 0, editDirty: true })
        _totalExhibitsSumInsured = val ? val : 0
        this.setAllSpecItem()
    }

    handleBlurInOutVal = (event, name) => {
        let val = event.target.value
        if (name === '_incomingExhibitionLimit') {
            this.setState({ incomeExhibitionLimit: val ? parseFloat(val) : 0 })
        } else {
            this.setState({ outExhibitionLimit: val ? parseFloat(val) : 0 })
        }
        this.setAllSpecItem()
    }

    _updateParentStateItems = (tableItems: any) => {
        this._updatePropsValues(tableItems)
        this.setState({ tableItems, editDirty: true })
        this._calculateSumOfSpecItem(tableItems)
    }

    _updatePropsValues = (data: any) => {
        let _data = {}
        data.map((item, index) => {
            _data[item.text] = item.valueInsured
        })
        this.props.values.exhibitsItems = _data
        // let props = this.props
        // data.map((item, index) => {
        //     props.values['sum' +
        //        (item.type).charAt(0).toUpperCase() + (item.type).slice(1)] = parseFloat(item.valueInsured).toFixed(2)
        //     props.values['price' +
        //         (item.type).charAt(0).toUpperCase() + (item.type).slice(1)] = parseFloat(item.valueStock).toFixed(2)
        //     props.setFieldTouched(
        //         `sum${(item.type).charAt(0).toUpperCase()}${(item.type).slice(1)}`,
        //         parseFloat(item.valueInsured).toFixed(2))
        // })
    }

    _calculateSumOfSpecItem = (tableItems) => {
        let total = 0

        tableItems.map((item) => {
            total += parseFloat(item.valueInsured)
        })
        this.setState({ sumOfSpecItem: Number(total) }, () => {
            this.setAllSpecItem()
        })
    }

    _calculateSum = () => {
        let total = 0

        this.state.tableItems.map((item) => {
            total += parseFloat(item.valueInsured)
        })

        this.props.values.totalSpecifiedItem = Number(total).toFixed(2)
        // return Number(total).toFixed(2)
        return Number(total)
    }

    csvDownload = () => {
        this.CsvTitle = 'category,description,value' + '\n' +
            'Pictures / Paintings / Prints,test,15000.55' + '\n' +
            'Antiques / Furniture,test,0.00' + '\n' +
            'Bronzes / Sculptures / Marbles,test,0.00' + '\n' +
            'Precious Metals / Coins / Medals,test,0.00' + '\n' +
            'Porcelain / Brittle Items,test,0.00' + '\n' +
            'Carpets / Rugs / Tapestries / Textiles,test,0.00' + '\n' +
            'Clocks / Barometers,test,0.00' + '\n' +
            'Fine wines and spirits,test,0.00' + '\n' +
            'Collectibles / Memorabilia,test,0.00' + '\n' +
            'Books / Maps / Ephemera,test,0.00'
        let filename = 'Museums Items.csv'
        const contentType = 'application/octet-stream'
        const blobSold = new Blob([this.CsvTitle], { type: contentType })
        saveAs(blobSold, filename)
    }

    MuseumsItem = () => {
        this.setState({ uploadMusemus: true })
    }

    okMuseumsItem = () => {
        this.setState({
            uploadMusemus: false,
            // showAgreed: false
        })
        let tableItems = this.state.tableItems
        var pushItem: any = UploadCsv.map((item, i) => {
            if (
                item[0] && item[1] && item[2] &&
                ((item[0] || '').toLowerCase()) !== 'category' &&
                ((item[1] || '').toLowerCase()) !== 'description' &&
                (((item[2]) || '') !== 'value' && Number(item[2]) !== 0)
            ) {
                return {
                    type: item[0],
                    text: item[1],
                    valueInsured: Number(item[2]),
                }
            }
            return 0
        })

        const filteredItems = pushItem.filter(item => item !== 0)
        tableItems = [...tableItems, ...filteredItems]
        // this.setState({tableItems});
        this._updateParentStateItems(tableItems)
    }

    cancelMuseumsItem = () => {
        this.setState({ uploadMusemus: false })
        UploadCsv = []
    }

    setAllSpecItem = () => {
        const {
            incomingExhibitionLimit,
            outgoingExhibitionLimit,
        } = this.props.values
        const { sumOfSpecItem } = this.state
        let total = (
            parseFloat(sumOfSpecItem) + parseFloat(incomingExhibitionLimit) + parseFloat(outgoingExhibitionLimit))
        this.props.values.sumOfAllItem = (total && total > 0) ? total : 0
    }

    render() {

        const {
            handleSubmit,
            quote,
            values,
            handleChange,
        } = this.props

        const { exhibitsVal, tableItems, editDirty } = this.state

        let errorList: any[] = []

        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        /**
         * Check if at least one item have been filled
         */
        let atLeastOneItem = (
            exhibitsVal !== 0
        ) ? false : true

        if (quote.step03.done && !this.props.editQuote) {
            this.props.history.push('/quote/' + this.props.match.params.id + '/step04')
        }

        if (this.props.updateDirty) {
            // console.log(this.props.dirty)
            this.props.dirty ? this.props.updateDirty(true) : this.props.updateDirty(false)
        }

        return (
            <div className="step03">
                {(!!Object.keys(this.props.errors).length && !!Object.keys(this.props.touched).length) && (
                    Object.keys(this.props.errors).filter(
                        (msg) => Object.keys(this.props.touched).includes(msg)
                    ).map((error, idx) => {
                        const msg = this.props.errors[error]
                        errorList.push(`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`)
                    })
                )}

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {(quote.step03.error) ? (
                    <Alert type="error">
                        Error: something went wrong please contact support
                    </Alert>
                ) : null}

                {
                    (this.state.uploadMusemus) ?
                        <PopUp
                            title="Museums Exhibits Items"
                            buttonText="Ok"
                            action={this.okMuseumsItem}
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={this.cancelMuseumsItem}
                        >
                            <CSVReader
                                cssClass="react-csv-input AgreedUpload"
                                label="Select CSV Museums Item File"
                                onFileLoaded={handleForce}
                            />
                        </ PopUp>
                        :
                        null
                }

                <form className="step03Form" onSubmit={handleSubmit}>
                    <div>
                        <div className="inline__group">
                            <div className="inline__items shadow">
                                <div className="inline__item title">Exhibits Sum Insured</div>
                                <div className="inline__icon">
                                    <ToolTip position="left">
                                        Total Exhibits Sum Insured for the whole collection - including specified items.
                                    </ToolTip>
                                </div>
                            </div>
                            <div className="exhibits">
                                <div className="quote__form__group">
                                    <label className="active">
                                        Total Exhibits insured comprising the permanent collection, specified items,
                                        incoming and outgoing exhibits
                                    </label>

                                    <div className="input">
                                        <div className="input__pound">
                                            &pound;
                                        </div>
                                        <input
                                            type="number"
                                            min="0"
                                            step="any"
                                            name="totalExhibitsSumInsured"
                                            id="totalExhibitsSumInsured"
                                            placeholder="0"
                                            onChange={handleChange}
                                            onBlur={this.handleBlur}
                                            value={values.totalExhibitsSumInsured}
                                        />
                                    </div>
                                </div>
                                <div className="quote__form__group">
                                    {/* empty value */}
                                </div>
                                <div className="museum_cover">
                                    <div className="quote__form__group">
                                        <label className="active income_exhibit">
                                            Incoming Exhibits within the premises insured
                                        </label>

                                        <div className="input">
                                            <div className="input__pound">
                                                &pound;
                                            </div>
                                            <input
                                                type="number"
                                                min="0"
                                                step="any"
                                                name="incomingExhibitionLimit"
                                                id="incomingExhibitionLimit"
                                                placeholder="0"
                                                onChange={handleChange}
                                                onBlur={(event) =>
                                                    this.handleBlurInOutVal(event, '_incomingExhibitionLimit')}
                                                value={values.incomingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                    <div className="quote__form__group">
                                        <label className="active">
                                            Outgoing Exhibits forming part of the permanent collection whilst on loan
                                        </label>

                                        <div className="input">
                                            <div className="input__pound">
                                                &pound;
                                            </div>
                                            <input
                                                type="number"
                                                min="0"
                                                step="any"
                                                name="outgoingExhibitionLimit"
                                                id="outgoingExhibitionLimit"
                                                placeholder="0"
                                                onChange={handleChange}
                                                onBlur={(event) =>
                                                    this.handleBlurInOutVal(event, '_outgoingExhibitionLimit')}
                                                value={values.outgoingExhibitionLimit}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="splitter--stripe" />
                            </div>
                        </div>
                        <div className="inline__group">
                            <div className="agreed_upload">
                                <div className="museumsupload">
                                    <p>Specified Items</p>
                                </div>
                                {/* href="../../../../src/images/AgreedItem.csv" download */}
                                <a className="agreeDownloadBtn" onClick={this.csvDownload}>
                                    {/* <span> */}
                                    Download CSV Template
                                    {/* </span> */}
                                </a>
                                <a onClick={this.MuseumsItem}>
                                    <span>
                                        Upload CSV
                                    </span>
                                </a>
                            </div>
                        </div>
                        <TableContent
                            tableItems={tableItems}
                            updateParentStateItems={this._updateParentStateItems}
                        />
                        <div>
                            <div className="table__titles shadow">
                                <div className="table__50-item">
                                    Total specified item value
                                </div>
                                <div className="table__30-item">
                                    {/* Total items */}
                                </div>
                                <div className="table__20-item">
                                    Total exhibit sum insured
                                </div>
                            </div>
                            <div className="table__content">
                                <div className="table__50-item">
                                    <h4>{this._calculateSum().toLocaleString('en-GB', {
                                        style: 'currency',
                                        currency: 'GBP',
                                    })}</h4>
                                </div>
                                <div className="table__30-item">
                                    {/*  */}
                                </div>
                                <div className="table__20-item">
                                    <h4>{Number(exhibitsVal).toLocaleString('en-GB', {
                                        style: 'currency',
                                        currency: 'GBP',
                                    })}</h4>
                                </div>
                            </div>
                        </div>

                        {this.props.editQuote && editDirty ? (
                            <div className="quote__form__group quote__form__group--update">
                                <Button
                                    type="submit"
                                >
                                    Update
                                </Button>
                            </div>
                        ) : null}

                        <div className="quote__form__group quote__form__group--submit">
                            <Button
                                type="submit"
                                onClick={() => window.scrollTo(0, 0)}
                                disabled={atLeastOneItem}
                            >
                                Save and continue
                            </Button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const Step03mForm = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        totalExhibitsSumInsured: Number(get(props, 'totalExhibitsSumInsured', 0)),
        totalSpecifiedItem: Number(get(props, 'totalSpecifiedItem', 0)),
        incomingExhibitionLimit: Number(get(props, 'incomingExhibitionLimit', 0)),
        outgoingExhibitionLimit: Number(get(props, 'outgoingExhibitionLimit', 0)),
        exhibitsItems: get(props, 'exhibitsItems', {}),
        sumOfAllItem: '',
    }),

    validationSchema: Yup.object().shape({
        totalExhibitsSumInsured: Yup.number()
            .min(5000, 'The Exhibits Sum Insured value can\'t be less than £5000'),
        // totalSpecifiedItem: Yup.number()
        //     .min(1000, 'The sum specified value can\'t be less than £1000'),
        totalSpecifiedItem: Yup.lazy(val => {
            if (val && _totalExhibitsSumInsured) {
                if (parseFloat(val) > parseFloat(_totalExhibitsSumInsured)) {
                    return Yup.number().max(
                        _totalExhibitsSumInsured,
                        'Cumulative value of specified items must not exceed total sum insured.'
                    )
                } else {
                    return Yup.number()
                }

            } else {
                return Yup.number()
            }
        }),
        sumOfAllItem: Yup.lazy(val => {
            if (parseFloat(val) > parseFloat(_totalExhibitsSumInsured)) {
                return Yup.number().max(
                    _totalExhibitsSumInsured,
                    `Cumulative value of specified items, incoming exhibition limit, outgoing exhibition 
                    limit must not exceed total sum insured.`
                )
            } else {
                return Yup.number()
            }
        }),
    }),

    handleSubmit: (values, { props, setSubmitting, resetForm }) => {
        let content = {
            'quote': {
                'id': props.match.params.id,
                'stockBusinessAssets': values.exhibitsItems,
                'totalExhibitsSumInsured': values.totalExhibitsSumInsured,
                'totalSpecifiedItem': values.totalSpecifiedItem,
                'incomingExhibitionLimit': values.incomingExhibitionLimit,
                'outgoingExhibitionLimit': values.outgoingExhibitionLimit,
            },
        }

        if (props.mta) {
            props.updateData(content)
        } else {
            if (props.editRenewal) {
                props.setStep03Renewals(content).finally(() => {
                    props.getRenewalVariation(props.renewalQuoteId)
                })
            } else {
                props.setStep03(content)
                props.getQuoteVariation(props.match.params.id)
            }
        }
        resetForm(content)

        if (props.editQuote) {
            setTimeout(props.update, 500)
        }
    },

})(Step03mFormHTML)

export default Step03mForm



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/EditQuote/components/Step03mView.tsx